import React, { useState, useEffect } from 'react';
import { GrPrevious, GrNext } from "react-icons/gr";
import '../styles/HeroSection.css';
import banner1 from '../images/banner1.jpeg'
import banner2 from '../images/banner-joska.jpeg'
import banner3 from '../images/banner-malindi.jpeg'
import banner4 from '../images/banner-joska2.jpeg'
import banner5 from '../images/banner-matuu.jpeg'
const HeroSection = () => {
    const [currentImage, setCurrentImage] = useState(0);

    const images = [
        banner1,
        banner2,
        banner3,
        banner4,
        banner5,
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prevImage) => (prevImage + 1) % images.length);
        }, 2000);

        return () => clearInterval(interval);
    }, [images.length]);

    const nextImage = () => {
        setCurrentImage((currentImage + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImage((currentImage - 1 + images.length) % images.length);
    };

    return (
        <div className="hero-section">
            <div className="carousel-container">
                <button onClick={prevImage} className="carousel-button"><GrPrevious /></button>
                <div className="carousel-image-container">
                    <img src={images[currentImage]} alt={`Image ${currentImage + 1}`} className="carousel-image" />
                </div>
                <button onClick={nextImage} className="carousel-button"><GrNext /></button>
            </div>
        </div>
    );
};

export default HeroSection;
